export default __webpack_public_path__ + "static/media/empty.2f86ac46.svg";